import useEffectOnce from 'hooks/useEffectOnce';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

const ActiveItemDetailsCardName = ({ name, type }) => {
  const [positionStyles, setPositionStyles] = useState({});
  const nameRef = useRef(null);

  const getPositionStyles = useCallback(() => {
    if (nameRef.current) {
      const height = Math.floor(nameRef.current.getBoundingClientRect().height);
      // const percent = name.length > 21 ? 54 : 50;
      setPositionStyles({
        position: 'absolute',
        top: `calc(${50}% - ${height / 2}px)`,
        left: 0,
        right: 0
      });
    }
  }, [name.length]);

  const getName = () => {
    if (type.toLowerCase() === 'prize') {
      return `$${name}`;
    } else if (name.length > 40) {
      const lastSpaceIndex = name.lastIndexOf(' ', 40);
      const trimmedName = lastSpaceIndex !== -1 ? name.slice(0, lastSpaceIndex) : name.slice(0, 40);
      return trimmedName + ' ...';
    } else {
      return name;
    }
  };

  useEffectOnce(() => {
    const timeoutId = setTimeout(getPositionStyles, 0);

    return () => clearTimeout(timeoutId);
  })

  useLayoutEffect(() => {
    getPositionStyles()
  }, [name, type, getPositionStyles]);

  return (
    <b
      className="cards-list__block-item-data-text"
      ref={nameRef}
      style={positionStyles}
    >
      {getName()}
    </b>
  );
}

export default ActiveItemDetailsCardName;
